import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
// import { getStaKvs } from "@/api/api-basic";
import { getStaKvs } from "@/api/api-operation-service";
import { State } from "vuex-class";
let SelectStation = class SelectStation extends Vue {
    constructor() {
        super(...arguments);
        this.stationList = [];
        this.staPkId = "";
    }
    getVisible() {
        this.getStaKvs();
    }
    getStationId() {
        if (this.stationId != this.staPkId) {
            this.staPkId = this.stationId;
        }
    }
    async getStaKvs() {
        // if (this.oprPkId == "") {
        //   this.stationList = [];
        //   this.staPkId = "";
        // } else {
        const json = { hasOpen: true };
        if (this.oprPkId && this.oprPkId != "") {
            json.oprPkId = this.oprPkId;
        }
        if (this.merchantPkId && this.merchantPkId != "") {
            json.merchantPkId = this.merchantPkId;
        }
        if (this.regionId && this.regionId != "") {
            json.regionId = this.regionId;
        }
        // if (!(this.sys.userType !== "admin" && this.oprPkId == "")) {
        const ret = await getStaKvs(json);
        if (ret.status === this.$config.apiStatus) {
            this.stationList = ret.data;
            if (this.isSelectFirst) {
                if (ret.data.length > 0) {
                    this.staPkId = ret.data[0].key;
                    this.$emit("value", this.staPkId);
                    this.$emit("on-change", this.staPkId);
                    this.$emit("on-first-change", this.staPkId);
                }
            }
        }
        else {
            if (this.isSelectFirst) {
                this.$emit("on-first-change", "");
            }
        }
        // }
        // }
    }
    selectStation(val) {
        val = val == undefined ? "" : val;
        this.staPkId = val;
        this.$emit("value", val);
        this.$emit("on-change", val);
    }
    mounted() {
        this.staPkId = this.stationId;
        // if (this.oprPkId != "") {
        this.getStaKvs();
        // }
    }
};
__decorate([
    Prop({ default: 200 })
], SelectStation.prototype, "width", void 0);
__decorate([
    Prop({ default: "" })
], SelectStation.prototype, "oprPkId", void 0);
__decorate([
    Prop({ default: "" })
], SelectStation.prototype, "merchantPkId", void 0);
__decorate([
    Prop({ default: "" })
], SelectStation.prototype, "regionId", void 0);
__decorate([
    Prop({ default: false })
], SelectStation.prototype, "isSelectFirst", void 0);
__decorate([
    Watch("oprPkId"),
    Watch("merchantPkId"),
    Watch("regionId")
], SelectStation.prototype, "getVisible", null);
__decorate([
    Watch("stationId")
], SelectStation.prototype, "getStationId", null);
__decorate([
    Model("value", { type: String })
], SelectStation.prototype, "stationId", void 0);
__decorate([
    State("sys")
], SelectStation.prototype, "sys", void 0);
SelectStation = __decorate([
    Component
], SelectStation);
export default SelectStation;
